import { ANALYTICS } from 'constants/api';
import axios from 'utils/axios';

export const getAssessmentWorkloadOverview = async (data) => {
    try {
        const result = await axios.get(ANALYTICS.v1.assessmentWorkloadOverview, { params: data });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to get assessment workload overview');
    }
};

export const getAssessmentSummary = async (data) => {
    try {
        const result = await axios.get(ANALYTICS.v1.assessmentSummary, { params: data });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to get assessment summary');
    }
};

export const getReportsAnalytics = async (data) => {
    try {
        const result = await axios.get(ANALYTICS.v1.reports, { params: data });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to get reports analytics');
    }
};
